module.exports = __webpack_public_path__ + "img/adp.b974d10a.svg";